import {createBrowserHistory} from 'history'
import {sessionStore} from "./storage";
let length = +sessionStore.hisLength||0
const h = createBrowserHistory({
    basename: '/h5'
});
h.listen(({action})=>{
    if(action==='PUSH')length++
    else if(action==='POP')length++
    sessionStore.hisLength = length
})
h.back = () => {
    const lo = window.location.href
    if (length>1) h.go(-1);
    else h.replace('/h5')
    setTimeout(function (){
        if( window.location.href===lo){
            h.replace('/h5')
        }
    },100)
}
export const history = h;
